import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/fonts.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import { store } from "./store";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#EB0A1E",
            borderRadius: 10,
            fontFamily: 'ToyotaFont',
            fontSize: "14px",
            colorBgLayout: "rgb(58 58 58)"
          },
          components: {
            Button: {
              defaultBg: "#EB0A1E",
              colorLink: "#EB0A1E",
              colorLinkHover: "#c30818",
              colorLinkActive: "#c30818",
            },
            Input: {
              borderRadius: 4,
              paddingInline: 12,
              paddingBlock: 6,
            },
            Select: {
              lineHeight: 2
            },
            Message: {
              margin: 10
            }
          }
        }}
      >
        {/* <AntdApp> */}
          <App /> 
        {/* </AntdApp> */}
      </ConfigProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
